/**
 * LGN Tooltips Initialization
 * Initializes Bootstrap 5 tooltips for product badges and other elements
 */

(function() {
  'use strict';

  /**
   * Initialize tooltips on page load
   */
  function initTooltips() {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');

    tooltipTriggerList.forEach(function(tooltipTriggerEl) {
      new bootstrap.Tooltip(tooltipTriggerEl, {
        trigger: 'hover focus', // Works on mobile tap + desktop hover
        placement: 'auto', // Auto-position based on available space
        fallbackPlacements: ['top', 'bottom', 'left', 'right'],
        boundary: 'viewport'
      });
    });
  }

  /**
   * Reinitialize tooltips after dynamic content loads
   * (for variant cards rendered via JS, collection filters, etc.)
   */
  function reinitTooltips() {
    // Dispose existing tooltips first to avoid duplicates
    const existingTooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    existingTooltips.forEach(function(el) {
      const tooltip = bootstrap.Tooltip.getInstance(el);
      if (tooltip) {
        tooltip.dispose();
      }
    });

    // Reinitialize
    initTooltips();
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTooltips);
  } else {
    initTooltips();
  }

  // Reinitialize after AJAX content loads (collection filters, load more)
  document.addEventListener('collection:products-loaded', reinitTooltips);

  // Export for manual calls
  window.LGN = window.LGN || {};
  window.LGN.initTooltips = initTooltips;
  window.LGN.reinitTooltips = reinitTooltips;
})();
